import React from 'react';

export const ArrowRight = ({ fill }: { fill: string }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="arrow_right_alt">
      <mask id="mask0_3458_7875" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect id="Bounding box" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3458_7875)">
        <path
          id="arrow_right_alt_2"
          d="M14 18L12.6 16.55L16.15 13H4V11H16.15L12.6 7.45L14 6L20 12L14 18Z"
          fill={fill}
        />
      </g>
    </g>
  </svg>
);
